export const adminLteConf = {
  skin: 'incontrol',
  //isSidebarLeftCollapsed: true,
  // isSidebarLeftExpandOnOver: false,
  // isSidebarLeftMouseOver: false,
  // isSidebarLeftMini: true,
  // sidebarRightSkin: 'dark',
  // isSidebarRightCollapsed: true,
  // isSidebarRightOverContent: true,
  // layout: 'normal',
  sidebarLeftMenu: [
    {label: 'Dashboard', route: 'inicio',root:'admin', iconClasses: 'fa fa-tachometer', pullRights: []},
    //{label: 'Mi Tienda', route: 'layout/configuration', iconClasses: 'flag-blanco.svg'},
    {label: 'Empresas', route: 'empresas',root:'root', iconClasses: 'fa fa-briefcase'},
    {label: 'Usuarios', route: 'usuarios',root:'root', iconClasses: 'fa fa-users'},
    {label: 'Formularios', route: 'formularios',root:'root', iconClasses: 'fa fa-check-square-o'},
    {label: 'Empleados', route: 'empleados',root:'admin', iconClasses: 'fa fa-address-book'},
    {label: 'Encuestas', route: 'encuestas',root:'admin', iconClasses: 'fa fa-address-book'}
  ]
};
